<section class="w-[95%] mx-auto mb-16">
  <section class="content-container">
    <section class="body-content">
      <router-outlet></router-outlet>
    </section>
  </section>
</section>
